var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('navbar'),_c('sidebar'),_c('intro',{attrs:{"cards":_vm.cards,"contactInfo":_vm.contactInfo}}),_c('about-us',{attrs:{"aboutInfo":_vm.aboutInfo}}),_c('services'),_c('clients'),_c('numbers',{attrs:{"cards":_vm.cards}}),_c('news'),_c('contact',{attrs:{"contactInfo":_vm.contactInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }